import React from 'react'
import { MaxValueLabel, MinValueLabel, SliderC, SliderWrapper } from '~/pages/Farmer/Survey/RequestEntries/AnswerForms/Slider'
import { SliderContainer } from '../../style'
import styled from 'styled-components'

interface Props {
  value: string
  onChange: (value: string | number) => void
}

const SliderTitle = styled.div`
text-align: left;
font-weight: 700;
color: rgb(94, 102, 114);
margin-bottom: 7px;
`

const FertilizerSlider: React.FC<Props> = ({ value, onChange }) => {

  return <SliderContainer style={{ marginBottom: 10 }}>
    <SliderTitle>{'Nutzbar:'}</SliderTitle>
    <SliderWrapper>
      <MinValueLabel style={{ fontWeight: 'normal' }}>{'0%'}</MinValueLabel>
      <SliderC
        step={1}
        rating={parseInt(value)}
        min={1}
        max={100}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      <MaxValueLabel style={{ fontWeight: 'normal' }}>{`${parseInt(value)}%`}</MaxValueLabel>
    </SliderWrapper>
  </SliderContainer>
}
export default FertilizerSlider